// useMailSchreiben.ts — „E-Mail schreiben“ an eine Adresse, im KMVS-Mailfenster.
//
// T-227/T-296 (07./12.10.2026): Mail-Adresse und Brief-Symbol im Kontakt
// öffneten Outlook per `mailto:` — gemeint war das Mailfenster von KMVS
// (`ComposeMailWindow`), aus dem die Mail mit Signatur, Postfach und
// Kontakt-Dokumenten rausgeht. Ohne Fensterverwaltung (außerhalb der
// App-Shell) bleibt `mailto:` der Ausweg, ebenso wenn der Editor nicht lädt.
//
// Der Editor wird VERZÖGERT geladen (wie in SandboxedMailBody): Der Helfer
// steckt in `EmailInput` und damit in jedem Formular — ein statischer Import
// zöge den Editor in jede Form und in jede jsdom-Testsuite.

import * as React from "react";
import { useWindowManagerOptional } from "../windowManager/WindowManagerContext";

/**
 * Liefert `schreiben(adresse, contactId?)`. Der Kontakt ist der, AUS dem
 * geschrieben wird — er steuert im Mailfenster die Dokument-Auswahl, den
 * Betreff-Assistenten und die Empfänger-Vorschläge.
 */
export function useMailSchreiben(): (adresse: string, contactId?: number | null) => void {
  const openWindow = useWindowManagerOptional()?.openWindow;
  return React.useCallback(
    (adresse: string, contactId?: number | null) => {
      const an = (adresse ?? "").trim();
      if (!an) return;
      const mailto = `mailto:${an}`;
      if (!openWindow) {
        window.location.href = mailto;
        return;
      }
      const kontakt = Number.isInteger(contactId) && (contactId as number) > 0 ? (contactId as number) : null;
      void import("./ComposeMailWindow")
        .then(({ openComposeWindow }) =>
          openComposeWindow(openWindow, {
            to: [an],
            ...(kontakt ? { contactId: kontakt, empfaengerKontextId: kontakt } : {}),
          }),
        )
        .catch(() => {
          window.location.href = mailto;
        });
    },
    [openWindow],
  );
}
